/**
 * Marketplace copy. Centralized so it can be moved into the i18n
 * dictionaries per locale without touching components.
 */
export const MP = {
  hero: {
    headline: "Find talent. Hire securely. Get it done.",
    sub: "Discover creators, DJs, artists, musicians, influencers, designers, developers and professionals. Protected payments, verified reviews and real reputation — all inside BeHot.now.",
    searchPlaceholder: "What do you need?",
    searchExamples: [
      "Female house vocalist",
      "DJ in Dubai",
      "Instagram influencer",
      "UGC creator",
      "Music video editor",
      "Mixing engineer",
      "Logo designer",
      "AI developer",
    ],
    primaryCta: "Search Marketplace",
    secondaryCta: "Sell a Service",
  },
  nav: {
    home: "Marketplace",
    hot: "HOT 🔥",
    explore: "Explore",
    categories: "Categories",
    talent: "Talent",
    requests: "Requests",
    favorites: "Favorites",
    orders: "Orders",
    sell: "Sell",
    earnings: "Earnings",
  },
  sections: {
    featured: "Featured Services",
    hotNow: "HOT 🔥 Right Now",
    ambassadorPicks: "Ambassador Picks",
    newTalent: "New Talent",
    topRated: "Top Rated",
    fastDelivery: "Fast Delivery",
    under50: "Under $50",
    mostSaved: "Most Saved",
  },
  preview: {
    ribbon: "Marketplace preview — visible to admins only",
    notFoundTitle: "Page not found",
    notFoundBody: "This page doesn't exist yet.",
  },
  sell: {
    title: "Sell on BeHot.now",
    verifiedRequiredTitle: "Seller verification required",
    verifiedRequiredBody:
      "To protect buyers, every seller completes a one-time identity verification (KYC for individuals, KYB for businesses). Review takes up to 5 working days.",
  },
  fees: {
    sellerFee: "15% seller fee",
    buyerFee: "2% buyer fee",
    protected: "Protected Payment — funds are held safely until you accept the delivery.",
  },
} as const;

export const MP_SELLER_FEE_RATE = 0.15;
export const MP_BUYER_FEE_RATE = 0.02;
export const MP_SAFETY_HOLD_DAYS = 16;
export const MP_EARNINGS_PENDING_DAYS = 5;
export const MP_REVIEW_HOURS = 72;
export const MP_MAX_RANK_HEAT_GRANT = 10;

/** Publishing a service is free; only optional featuring costs Heat. */
export const MP_PUBLISH_IS_FREE = true;
